import React, { useState, useRef, useEffect } from 'react';
import googleMapsRespData from '../mock/googleMapsResp.json';
import '../css/partnersDetails.css';
import {APIProvider, Map, AdvancedMarker, Pin, InfoWindow, MapControl, ControlPosition } from '@vis.gl/react-google-maps';
import { useTabletMediaQuery, useMobileMediaQuery } from '../utils';
import CustomButton from './CustomButton';
import { IoSearch } from "react-icons/io5";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import PlaceholderLoading from 'react-placeholder-loading';
import { RiMapPinLine } from "react-icons/ri";
import Badge from '@mui/material/Badge';
import CustomAlert from './CustomAlert';
import iconDecathlon from '../assets/svg/iconDecathlon.svg';
import { AiOutlineStop } from "react-icons/ai";
import { toast } from "react-toastify";

function GoogleMap(props) {

  const { 
    listaLojasAderentes,
    nomeparceiro,
    imgLogo
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const isTablet = useTabletMediaQuery();
  const isMobile = useMobileMediaQuery();
  const [myLocation, setMyLocation] = useState('');
  const [newLocation, setNewLocation] = useState(null);
  const initialPosition = listaLojasAderentes.length > 0
  ? { lat: parseFloat(listaLojasAderentes[0].latitude), lng: parseFloat(listaLojasAderentes[0].longitude) }
  : { lat: myLocation?.latitude, lng: myLocation?.longitude }; 
  const [selectedMarker, setSelectedMarker] = useState(null);
  const markersRefs = useRef(listaLojasAderentes.map(() => React.createRef()));
  const [seacrhPartner, setSeacrhPartner] = useState('');
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [showPartnersList, setShowPartnersList] = useState(false);
  const [toggleSected, setToggleSelected] = useState(false);

  const handleSelectedMarker = (index, item) => {
    setSelectedMarker(index);
    setNewLocation(item);
  };

  const handleSelectedMarkerMobile = (index, item) => {
    setSelectedMarker(index);
    setNewLocation(item);
    if (!isTablet) {
      handleSelectToggle()
    }
  };


  useEffect(() => {
    const delay = setTimeout(() => {
    setIsLoading(false); 
    }, 1000); 

    return () => clearTimeout(delay); 
  }, []);

  const handleSelectToggle = () => {
    setToggleSelected((prevState) => !prevState);
  };

  const hadleBtnClickSearchPartners = () => {
    //setSeacrhPartner('')
    //alert('btn search')
  };

  const handleClickShowInfo = () => {
    setOpenInfoModal(true)
  };

  const handleClickShowPartnersList = () => {
    setShowPartnersList(!showPartnersList)
  };
  
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          setMyLocation({ latitude, longitude });
        },
        error => {
          toast.dismiss();
          toast.error("Erro ao obter localização. Por favor, tente mais tarde.", {
            icon: <AiOutlineStop/>
          });
        }
      );
    } else {
      toast.dismiss();
      toast.error("A geolocalização não é suportada pelo seu navegador!", {
        icon: <AiOutlineStop/>
      });
    }
  }, []);

  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; 
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; 
    return distance;
  }
  

  let closestPoint = null;
  let minDistance = Number.MAX_VALUE;

  listaLojasAderentes.forEach((item, index) => {
    const distance = calculateDistance(myLocation.latitude, myLocation.longitude, parseFloat(item.latitude), parseFloat(item.longitude));

    if (distance < minDistance) {
      minDistance = distance;
      closestPoint = item;
    }
  });


  const [filteredData, setFilteredData] = useState(listaLojasAderentes);

  const handleSearch = (searchText) => {
    const filteredList = listaLojasAderentes.filter((item) =>
      item.nome.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filteredList);
  };

  const renderContentInfo = ()  => {
    return (
      <div className='mainGoogleMapGridWithOutInfoViewContainerDesPartnersDetails'>
        
        {/* <div className='columnViewGoogleMapViewContainerPartnersDetails'>
          { isLoading ? <PlaceholderLoading shape="rect" width={250} height={25}/> : (
              <>
              <div className='textWrapperPartnersDetails'>
                  <input 
                      className='inputTextPartnersDetails'
                      type="text" 
                      placeholder='Pesquise uma loja aderente'
                      value={seacrhPartner}
                      onChange={(event) => {
                        setSeacrhPartner(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      maxLength={50}
                  />
                  <div className='findIconViewPartnersDetails' onClick={handleClickShowPartnersList}><IoIosArrowDown className='findIconPartnersDetails' /></div>
                  <div className='findIconViewPartnersDetails' onClick={handleClickShowInfo}><AiOutlineInfoCircle className='findIconPartnersDetails' /></div>
                  <CustomAlert 
                    title='Como Funciona'
                    text='Contacta nos para saber mais informação'
                    type='info'
                    show={openInfoModal} 
                    onHide={() => setOpenInfoModal(false)} 
                />  
              </div> 
              </>
          )}
        </div> */}
        { !showPartnersList &&
        <>
          { isLoading ? <PlaceholderLoading shape="rect" width={150} height={20}/> : (
          <div className='txtViewTitleListItemsGoogleMapViewContainerDesPartnersDetails'>
            <Badge badgeContent={listaLojasAderentes.length} style={{color: '#fff'}}>
              <div className='txtTitleListItemsGoogleMapViewContainerPartnersDetails'>Lojas aderentes</div>
            </Badge>
          </div>
          )}
          <div className='mainGoogleMapGridWithOutInfoViewContainerPartnersDetails'>
            <div className={ isTablet ? 'mainGoogleMapGridViewContainerPartnersDetails' : 'mainGoogleMapGridViewContainerPartnersDetailsMobile'}>
              
            { filteredData.map((item, index) =>(
              <div key={index} onClick={() => handleSelectedMarker(index, item)} className='columnGridViewGoogleMapViewContainerPartnersDetails'>
                { isLoading ? <PlaceholderLoading shape="rect" width={300} height={125}/> : (
                  <>
                  <div className='rowGridViewGoogleMapViewContainerPartnersDetails'>
                    {/* <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{nomeparceiro} <br/> {item.nome}</div> */}
                    <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{item.nome}</div>
                    <img src={imgLogo} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                  </div>
                  <div className='columnGridSubLineViewGoogleMapViewContainerPartnersDetails'>
                      <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>Endereço</div>
                      <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'><RiMapPinLine /> {item.morada}</div>
                      <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'>{item.codigoPostal}</div>
                  </div>
                  <div className='columnGridSubViewGoogleMapViewContainerPartnersDetails'>
                    <CustomButton 
                        text={'Ver no mapa'} 
                        textColor={'#00214D'}
                        //onPress={() => handleSelectedMarker(index)} 
                        hasArrow
                        iconType={'right'}
                        iconColor={'#00214D'}
                        hasSubLine
                    />
                  </div>
                  </>
                )}
              </div>
            ))}
            </div>
          </div>
          </>
        }
      </div>
    );
  };

  const renderContentInfoMobile = () => {
    return (
      <div className='toggleMainViewContainerPartnersDetailsMobile'>
        <div className='selectViewTypeMainContainerPartnersDetailsMobile'>
          <button className={ !toggleSected ? 'btnSelectedViewTypeContainerPartnersDetailsMobile' : 'btnNoSelectedViewTypeContainerPartnersDetailsMobile'} onClick={handleSelectToggle}>Mapa</button>
          <button className={ toggleSected ? 'btnSelectedViewTypeContainerPartnersDetailsMobile' : 'btnNoSelectedViewTypeContainerPartnersDetailsMobile'} onClick={handleSelectToggle}>Lista</button>
        </div>
      </div>
    )
  }

  const renderTitleInfoMobile = () => {
    return (
      <div className={ isMobile ? 'txtViewTitleListTopItemsGoogleMapViewContainerPartnersDetailsTablet' : 'txtViewTitleListTopItemsGoogleMapViewContainerPartnersDetails'}>
        <Badge badgeContent={listaLojasAderentes.length} style={{color: '#fff'}}>
          <div className='txtTitleListItemsGoogleMapViewContainerPartnersDetails'>Lojas aderentes</div>
        </Badge>
      </div>
    )
  }

  const [isAtBottom, setIsAtBottom] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 10; // Offset for smoother detection
        setIsAtBottom(atBottom);
      }
    };

    const container = containerRef.current;
    if (container) { // Check if container exists before adding event listener
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const renderContentInfoToggleSelectedMobile = () => {
    return (
      <div ref={containerRef} className='mainGoogleMapGridWithOutInfoViewContainerDesPartnersDetailsMobile'>
          <div className={ isMobile ? 'txtViewTitleListTopItemsGoogleMapViewContainerPartnersDetailsMobTablet' : 'txtViewTitleListItemsGoogleMapViewContainerPartnersDetailsMobile'}>
            <Badge badgeContent={listaLojasAderentes.length} style={{color: '#fff'}}>
              <div className='txtTitleListItemsGoogleMapViewContainerPartnersDetails'>Lojas aderentes</div>
            </Badge>
          </div>
        <div className='mainGoogleMapScrollViewContainerPartnersDetailsMobile'>
          
          { filteredData.map((item, index) =>(
            <div key={index} onClick={() => handleSelectedMarkerMobile(index, item)} className='columnGridViewGoogleMapViewContainerPartnersDetailsMobile'>
              { isLoading ? <PlaceholderLoading shape="rect" width={300} height={125}/> : (
                <>
                <div className='rowGridViewGoogleMapViewContainerPartnersDetails'>
                  {/* <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{nomeparceiro} <br/> {item.nome}</div> */}
                  <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{item.nome}</div>
                  <img src={imgLogo} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                </div>
                <div className='columnGridSubLineViewGoogleMapViewContainerPartnersDetails'>
                    <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>Endereço</div>
                    <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'><RiMapPinLine /> {item.morada}</div>
                    <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'>{item.codigoPostal}</div>
                </div>
                <div className='columnGridSubViewGoogleMapViewContainerPartnersDetails'>
                  <CustomButton 
                      text={'Ver no mapa'} 
                      textColor={'#00214D'}
                      //onPress={() => handleSelectedMarker(index)} 
                      hasArrow
                      iconType={'right'}
                      iconColor={'#00214D'}
                      hasSubLine
                  />
                </div>
                </>
              )}
            </div>
          ))}
          { toggleSected &&
            <div className='toggleListViewContainerPartnersDetailsMobile' style={{ bottom: isAtBottom ? '0px' : '5px' }}>
              <div className='selectViewTypeMainContainerPartnersDetailsMobile'>
                <button className={ !toggleSected ? 'btnSelectedViewTypeContainerPartnersDetailsMobile' : 'btnNoSelectedViewTypeContainerPartnersDetailsMobile'} onClick={handleSelectToggle}>Mapa</button>
                <button className={ toggleSected ? 'btnSelectedViewTypeContainerPartnersDetailsMobile' : 'btnNoSelectedViewTypeContainerPartnersDetailsMobile'} onClick={handleSelectToggle}>Lista</button>
              </div>
            </div>
          }
        </div>
        
      </div>
    )
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
        const clickedOutside = markersRefs.current.every(ref => 
            ref.current && !ref.current.contains(event.target)
        );

        if (clickedOutside) {
            setSelectedMarker(null);
        }
    };

    if (selectedMarker) {
        document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, [selectedMarker, markersRefs]);

    
  return (
    <>
      { !isTablet &&
        <div className= 'mainGoogleMapGridViewContainerPartnersDetailsMobile'>
          
          {/* <div className='columnViewGoogleMapViewContainerPartnersDetailsMobile'>
            { isLoading ? <PlaceholderLoading shape="rect" width={250} height={25}/> : (
                <>
                <div className='textWrapperPartnersDetails'>
                    <input 
                        className='inputTextPartnersDetails'
                        type="text" 
                        placeholder='Pesquise uma loja parceira'
                        value={seacrhPartner}
                        onChange={(event) => {
                          setSeacrhPartner(event.target.value);
                          handleSearch(event.target.value);
                        }}
                        maxLength={50}
                    />
                    <div className='findIconViewPartnersDetails' onClick={hadleBtnClickSearchPartners}><IoSearch className='findIconPartnersDetails' /></div>
                </div>
                </>
            )}
          </div> */}
          { toggleSected &&
            renderContentInfoToggleSelectedMobile()     
          }
      </div>
      }
      { !toggleSected &&
      <>
        <div className='mainGoogleMapTestViewContainerPartnersDetails'>
          { isLoading ? <PlaceholderLoading shape="rect" width={350} height={350}/> : (
            <>
            <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY} >
                
                <Map 
                  center={ newLocation ? { lat: parseFloat(newLocation.latitude), lng: parseFloat(newLocation.longitude) } : (closestPoint ? { lat: parseFloat(closestPoint.latitude), lng: parseFloat(closestPoint.longitude) } : initialPosition)}
                  zoom={15}
                  mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
                  disableDefaultUI={true}>
                    
                  { listaLojasAderentes.map((item, index) =>(
                    <React.Fragment  key={index}>
                      <AdvancedMarker 
                        ref={markersRefs.current[index]}  
                        position={{  lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }} 
                        onClick={ () => handleSelectedMarker(index, item) } 
                      >
                          <Pin
                              background={ selectedMarker === index ? "#00214D" : "#15D4B6" }
                              borderColor={ selectedMarker === index ? "#00214D" : "#15D4B6"}
                              glyphColor={ selectedMarker === index ? "#15D4B6" : "#00214D" }
                              glyph={"M"}
                          />
                      </AdvancedMarker>
                      { selectedMarker === index  && (
                        <InfoWindow
                          anchor={markersRefs.current[index].current}
                          maxWidth={328}
                          disableAutoPan
                          className='infoWindowPartnersDetails'
                          onClose={() => setSelectedMarker(null)}>
                              <div onClick={() => setSelectedMarker(null)} className='columnViewGoogleMapViewContainerPartnersDetails'>
                                  <div className='rowViewGoogleMapViewContainerPartnersDetails'>
                                      <div className='columnViewGoogleMapViewContainerPartnersDetails'>
                                          {/* <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{nomeparceiro}</div> */}
                                          <div className='txtTitleStoreNameGoogleMapViewContainerPartnersDetails'>{item.nome}</div>
                                          <div className='txtStoreNameGoogleMapViewContainerPartnersDetails'>
                                            <span className='txtStoreNameGoogleMapViewContainerPartnersDetails'>{item.morada} </span>
                                            <span className='txtStoreNameGoogleMapViewContainerPartnersDetails'>{item.codigoPostal}</span>
                                          </div>
                                      </div>
                                      <img src={imgLogo} alt="imagem" className="iconPartnerLogoSvgPartnersDetails" />
                                  </div>
                              </div>
                        </InfoWindow>
                      )}
                    </React.Fragment>
                  ))}
                  { isTablet ? (
                  <MapControl position={ControlPosition.LEFT}>
                  { 
                    renderContentInfo()
                  }
                </MapControl>
                  ) : (
                    <>
                    
                    <MapControl position={ControlPosition.TOP_LEFT}>
                      { 
                        renderTitleInfoMobile()
                      }
                    </MapControl>
                    <MapControl position={ControlPosition.BOTTOM_CENTER}>
                      { 
                        renderContentInfoMobile()
                      }
                    </MapControl>
                    </>
                  )}
                </Map>
                
            </APIProvider>
            </>
          )}
        </div>
      </>
      }
    </>
  )
}

export default GoogleMap
